import { useEffect, useState } from 'react';

// Styled inline (MakePorn dark + orange look) so it renders correctly regardless of
// any CSS load/cache state. Behaviour mirrors fuckable's age gate: confirming is the
// user gesture that lets the grid videos start autoplaying.

const overlayStyle = {
    position: 'fixed', inset: 0, zIndex: 2000,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20,
    background: 'rgba(0,0,0,0.82)',
    backdropFilter: 'blur(16px) saturate(1.2)',
    WebkitBackdropFilter: 'blur(16px) saturate(1.2)',
};

const cardStyle = {
    position: 'relative', width: '100%', maxWidth: 440,
    background: 'linear-gradient(180deg, #111 0%, #0a0a0a 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderTop: '1px solid rgba(255,144,0,0.18)',
    borderRadius: 24, padding: '32px 28px 26px',
    boxShadow: '0 24px 80px rgba(0,0,0,0.6), 0 0 60px rgba(255,144,0,0.05)',
    textAlign: 'center',
};

const kickerStyle = {
    display: 'inline-flex', alignItems: 'center', gap: 7,
    fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase',
    color: '#ff9000',
    background: 'rgba(255,144,0,0.1)', border: '1px solid rgba(255,144,0,0.25)',
    padding: '5px 12px', borderRadius: 100,
};
const dotStyle = { width: 6, height: 6, borderRadius: '50%', background: '#ff9000', boxShadow: '0 0 8px rgba(255,144,0,0.7)' };
const titleStyle = { fontSize: 26, fontWeight: 800, letterSpacing: '-0.02em', color: '#fff', margin: '18px 0 8px' };
const subStyle = { fontSize: 14, lineHeight: 1.6, color: 'rgba(255,255,255,0.55)', margin: 0 };
const btnsWrap = { display: 'flex', flexDirection: 'column', gap: 10, marginTop: 24 };
const primaryBtn = {
    width: '100%', height: 52, border: 'none', borderRadius: 14,
    background: '#ff9000', color: '#000',
    fontFamily: 'inherit', fontSize: 15, fontWeight: 800, letterSpacing: '0.01em',
    cursor: 'pointer', boxShadow: '0 8px 24px rgba(255,144,0,0.35)',
};
const ghostBtn = {
    width: '100%', height: 48, borderRadius: 14,
    border: '1px solid rgba(255,255,255,0.12)', background: 'transparent',
    color: 'rgba(255,255,255,0.5)', fontFamily: 'inherit', fontSize: 14, fontWeight: 700,
    cursor: 'pointer',
};
const fineStyle = { margin: '16px 0 0', fontSize: 11.5, lineHeight: 1.5, color: 'rgba(255,255,255,0.35)' };

export function AgeGatePopup({ onConfirm }) {
    const [rejected, setRejected] = useState(false);

    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, []);

    return (
        <div style={overlayStyle}>
            <div style={cardStyle}>
                {!rejected ? (
                    <>
                        <span style={kickerStyle}><span style={dotStyle} /> Adults only</span>
                        <h2 style={titleStyle}>You must be 18+</h2>
                        <p style={subStyle}>
                            This site contains explicit AI-generated adult content.
                            You must be <b style={{ color: '#fff' }}>18 or older</b> to enter.
                        </p>
                        <div style={btnsWrap}>
                            <button type="button" style={primaryBtn} onClick={onConfirm}>I&apos;m 18+ — Enter</button>
                            <button type="button" style={ghostBtn} onClick={() => setRejected(true)}>I&apos;m under 18</button>
                        </div>
                        <p style={fineStyle}>
                            By entering you confirm you are of legal age and that adult content is legal where you live.
                        </p>
                    </>
                ) : (
                    <>
                        <h2 style={titleStyle}>Come back when you&apos;re older</h2>
                        <p style={subStyle}>You must be <b style={{ color: '#fff' }}>18+</b> to access this site.</p>
                    </>
                )}
            </div>
        </div>
    );
}
